import { Checkbox, FormControlLabel } from "@mui/material";
import React from "react";

export default function BaseCheckbox({
  label,
  checked,
  error,
  errorMsg,
  color = "#0F40AE",
  disabled = false, // capture disabled prop
  ...props
}) {
  const activeIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 17 18" fill="none">
      <rect y="0.0576477" width="17" height="17.318" rx="3" fill={color} />
      <path
        d="M4 7.90169L6.1 11.2634C7.2 9.83724 10.12 6.61812 13 5.15118"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );

  const inactiveIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 17 18" fill="none">
      <rect
        x="0.5"
        y="1.15628"
        width="16"
        height="16.318"
        rx="2.5"
        stroke={disabled ? "#A0A0A0" : "#4D4D4D"}
      />
    </svg>
  );

  const checkedIcon = disabled
    ? React.cloneElement(activeIcon, { opacity: 0.5 }) // greyed-out when disabled
    : activeIcon;

  const icon = disabled
    ? React.cloneElement(inactiveIcon, { opacity: 0.5 }) // greyed-out when disabled
    : inactiveIcon;

  return (
    <div>
      <FormControlLabel
        style={{ margin: 0, padding: 0 }}
        control={
          <Checkbox
            style={{ margin: 0, padding: 0 }}
            checkedIcon={checkedIcon}
            icon={icon}
            checked={checked}
            disabled={disabled} // pass disabled to MUI Checkbox
            {...props}
          />
        }
        label={label ? <p className="font-light ml-2">{label}</p> : ""}
      />
      {error && <p className="text-[#d32f2f] ml-2 text-xs">{errorMsg}</p>}
    </div>
  );
}
